import React, { Component, Fragment } from 'react';
import moment from 'moment';

import { unescapeText } from '../../../../constants/components';
import i18n from '../../../../i18n/i18n.js';

type Props = {
    index: number,
    status: string,
    item: {
        next_billing_date: number,
        type: string,
        created_at: number,
        expires_at: number,
        formatted_amount: number,
        unsubscribe_url: string,
        asset_title: string,
        next_billing_date: number,
    },
    content: boolean,
    subscriptionsData: Object,
    handleContentClick: Function,
};

export default class TransactionItem extends Component<Props> {
    render() {
        const { lng } = this.props;
        let status;

        const now = moment.utc();
        const isNowAfter = now.isAfter(
            moment(this.props.item.next_billing_date * 1000).utc()
        );

        let isNowAfterPurchases = false;
        if (!this.props.subscriptionsData) {
            isNowAfterPurchases = now.isAfter(
                moment(this.props.item.expires_at * 1000).utc()
            );
        }

        return (
            <Fragment>
                <div
                    className="acc-btn"
                    onClick={() =>
                        this.props.handleContentClick(this.props.index)
                    }
                >
                    <h5>
                        {!this.props.subscriptionsData
                            ? unescapeText(this.props.item.item_title)
                            : unescapeText(this.props.item.asset_title)}
                        {!this.props.subscriptionsData ? (
                            <span
                                className={
                                    'asset_status ' +
                                    (this.props.status === 'active'
                                        ? `active`
                                        : this.props.item.type === 'revoked'
                                            ? `inactive`
                                            : isNowAfterPurchases
                                                ? `inactive`
                                                : `active`)
                                }
                            >
                                {isNowAfterPurchases
                                    ? 'expired'
                                    : this.props.item.type}
                            </span>
                        ) : // Status to be fixed with notifications
                        this.props.item.status === 'canceled' ? (
                            <span className="asset_status expired">
                                {i18n.t('canceled', { lng })}
                            </span>
                        ) : (
                            <span className="billing-date">
                                {moment(
                                    this.props.item.next_billing_date * 1000
                                )
                                    .utc()
                                    .format('D MMM YYYY HH:mm')}
                            </span>
                        )}
                    </h5>
                    <i className="ipic_arrow-d" />
                </div>
                <div
                    className={
                        'acc-content ' +
                        (this.props.content[this.props.index] ? 'open' : '')
                    }
                >
                    <div className="acc-content-inner">
                        {!this.props.subscriptionsData
                            ? [
                                  <p key={2}>
                                      {i18n.t('purchased', { lng })}:
                                      <strong>
                                          {' '}
                                          {moment(
                                              this.props.item.created_at * 1000
                                          )
                                              .utc()
                                              .format('D MMM YYYY HH:mm')}{' '}
                                          (UTC)
                                          {this.props.item
                                              .purchased_access_fee_type ===
                                          'subscription'
                                              ? ', subscription'
                                              : ''}
                                      </strong>
                                  </p>,
                                  this.props.item.purchased_access_fee_type !==
                                      'subscription' &&
                                      this.props.item.type !== 'granted' &&
                                      this.props.item.purchased_amount !==
                                          undefined &&
                                      this.props.item.purchased_amount !==
                                          '' && (
                                          <p key={7}>
                                              Price:{' '}
                                              <strong>
                                                  {`${
                                                      this.props.item
                                                          .purchased_currency
                                                  }${parseFloat(
                                                      this.props.item
                                                          .purchased_amount
                                                  ).toFixed(2)} / `}
                                                  {
                                                      this.props.item
                                                          .purchased_access_fee_description
                                                  }
                                              </strong>
                                          </p>
                                      ),
                                  this.props.item.purchased_access_fee_type !==
                                      'subscription' && (
                                      <p key={4}>
                                          {this.props.item.type === 'expired' ||
                                          this.props.item.type === 'purchased'
                                              ? this.props.item.revoked === 0
                                                  ? this.props.status !==
                                                    'active'
                                                      ? 'Expired at: '
                                                      : 'Expires at: '
                                                  : ''
                                              : ''}
                                          <strong>
                                              {this.props.item.expires_at &&
                                                  this.props.item.type !==
                                                      'granted' &&
                                                  moment(
                                                      this.props.item
                                                          .expires_at * 1000
                                                  )
                                                      .utc()
                                                      .format(
                                                          'D MMM YYYY HH:mm'
                                                      )}{' '}
                                              {this.props.item.expires_at &&
                                                  this.props.item.type !==
                                                      'granted' &&
                                                  '(UTC)'}
                                          </strong>
                                      </p>
                                  ),
                                  this.props.item.purchased_access_fee_type ===
                                      'subscription' && (
                                      <p key={4}>
                                          Subscription:{' '}
                                          <strong>
                                              {this.props.item.status !==
                                              'free-trial'
                                                  ? `${
                                                        this.props.item
                                                            .purchased_currency
                                                    }${parseFloat(
                                                        this.props.item
                                                            .purchased_amount
                                                    ).toFixed(2)} / `
                                                  : 'Free trial'}
                                              {
                                                  this.props.item
                                                      .purchased_access_fee_description
                                              }
                                          </strong>
                                      </p>
                                  ),
                                  this.props.item.purchased_access_fee_type ===
                                      'subscription' &&
                                      this.props.status === 'active' && (
                                          <p key={5}>
                                              {i18n.t('next_transaction', {
                                                  lng,
                                              })}
                                              :
                                              <strong>
                                                  {' '}
                                                  {moment(
                                                      this.props.item
                                                          .expires_at * 1000
                                                  )
                                                      .utc()
                                                      .format(
                                                          'D MMM YYYY HH:mm'
                                                      )}{' '}
                                                  {this.props.item.expires_at &&
                                                      '(UTC)'}
                                              </strong>
                                          </p>
                                      ),
                              ]
                            : [
                                  <p key={1}>
                                      {i18n.t('purchased', { lng })}:
                                      <strong>
                                          {' '}
                                          {moment(
                                              this.props.item.created_at * 1000
                                          )
                                              .utc()
                                              .format('D MMM YYYY HH:mm')}{' '}
                                          {this.props.item.created_at &&
                                              '(UTC)'}
                                      </strong>
                                  </p>,
                                  <p key={3}>
                                      {i18n.t('subscription', { lng })}:
                                      <strong
                                          className={
                                              this.props.item.status !==
                                              'free-trial'
                                                  ? ''
                                                  : 'free-color'
                                          }
                                      >
                                          {' '}
                                          {this.props.item.status !==
                                          'free-trial'
                                              ? `${this.props.item.currency}${
                                                    this.props.item.amount
                                                }`
                                              : i18n.t('free_trial', { lng })}
                                      </strong>
                                  </p>,
                                  this.props.item.status !== 'canceled' ? (
                                      <p key={4}>
                                          {i18n.t('next_transaction', { lng })}
                                          {':'}
                                          <strong>
                                              {' '}
                                              {moment(
                                                  this.props.item
                                                      .next_billing_date * 1000
                                              )
                                                  .utc()
                                                  .format(
                                                      'D MMM YYYY HH:mm'
                                                  )}{' '}
                                              {this.props.item
                                                  .next_billing_date && '(UTC)'}
                                          </strong>
                                      </p>
                                  ) : !isNowAfter ? (
                                      <p key={4}>
                                          {i18n.t('will_end', { lng })}
                                          {':'}
                                          <strong>
                                              {' '}
                                              {moment(
                                                  this.props.item
                                                      .next_billing_date * 1000
                                              )
                                                  .utc()
                                                  .format(
                                                      'D MMM YYYY HH:mm'
                                                  )}{' '}
                                              {this.props.item
                                                  .next_billing_date && '(UTC)'}
                                          </strong>
                                      </p>
                                  ) : null,
                                  this.props.item.status !== 'canceled' && (
                                      <a
                                          key={5}
                                          className="cancel-subscription"
                                          onClick={e => {
                                              e.preventDefault();
                                              this.props.handleUnsubscribe(
                                                  this.props.item
                                                      .unsubscribe_url,
                                                  this.props.item.asset_title,
                                                  this.props.item
                                                      .next_billing_date
                                              );
                                          }}
                                      >
                                          {i18n.t('cancel_subscription', {
                                              lng,
                                          })}{' '}
                                          &#187;
                                      </a>
                                  ),
                              ]}
                    </div>
                </div>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Forms/History/TransactionItem.js